import React from "react";
import styles from "./ticTacToe.module.scss";

export default function Board(props) {
  return <div className={styles.board} {...props}></div>;
}
